import { render, staticRenderFns } from "./InvoicesSettingsTab.vue?vue&type=template&id=22454fb4&scoped=true"
import script from "./InvoicesSettingsTab.vue?vue&type=script&lang=js"
export * from "./InvoicesSettingsTab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22454fb4",
  null
  
)

export default component.exports